import Box from '@mui/material/Box';
import VideoLarge from 'assets/svg/video_large.svg';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { VideoWrapper } from '../../styles/create-video.styled';
import MessageView from '../view/MessageView';
import VideoPlayer from './VideoPlayer';
import VideoRecorder from './VideoRecorder';

const VideoPreview = ({ values, onChange, onRemove }) => {
  const [emojiReactionsVisible, setEmojiReactionsVisible] = useState();
  const account = useSelector((state) => state.settings.account);

  useEffect(() => {
    if (emojiReactionsVisible) {
      setTimeout(() => {
        setEmojiReactionsVisible(false);
      }, 4000);
    }
  }, [emojiReactionsVisible]);

  const onEmojiReaction = (emoji) => {
    setEmojiReactionsVisible(emoji.Icon);
  };

  return (
    <MessageView
      isPreview
      account={account}
      message={values}
      onReaction={onEmojiReaction}
      renderVideo={
        values.enableVideo === '1'
          ? () => (
              <>
                <VideoWrapper>
                  {values.video_source === 'camera' && values.video_url && (
                    <VideoPlayer
                      video_url={values.video_url}
                      thumbnail_url={values.video_url}
                    />
                  )}
                  {values.video_source === 'camera' && !values.video_url && (
                    <VideoRecorder values={values} onChange={onChange} />
                  )}
                  {values.video_source === 'url' && values.video_url && (
                    <Box className="url_container">
                      <VideoPlayer
                        video_url={values.video_url}
                        thumbnail_url={values.video_url}
                      />
                    </Box>
                  )}
                  {values.video_source === 'upload' &&
                    (values.video || values.video_url) && (
                      <VideoPlayer
                        playing={false}
                        width="100%"
                        height="100%"
                        className="embed-responsive embed-responsive-16by9 video-container"
                        video_url={values.video || values.video_url}
                        thumbnail_url={values.cover}
                      />
                    )}
                  {!values.video_source && (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flex={1}
                    >
                      <img src={VideoLarge} alt="video_icon" />
                    </Box>
                  )}
                </VideoWrapper>
              </>
            )
          : null
      }
    />
  );
};

export default VideoPreview;
